import AuthForm, {STATE_LOGIN} from '../components/AuthForm';
import React from 'react';
import {Card, Col, Row} from 'reactstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {login} from "../actions/userAction";
import {USER_TYPE} from "../constants/appConstants";
import bgLogin from '../assets/img/bg/bg-login.jpg';
import transparency from '../assets/img/bg/transicao-login.png';
import API from "../resources/index";


class AuthPage extends React.Component {
    auth = API.authResource;

    handleAuthState = authState => {
        if (authState === STATE_LOGIN) {
            this.props.history.push('/login');
        } else {
            this.props.history.push('/signup');
        }
    };

    handleLogoClick = () => {
        this.props.history.push('/');
    };

    handleSubmit = (event, state) => {
        if (this.props.authState === STATE_LOGIN) {
            this.auth.login(state, {
                keys: {
                    expand: [
                        'admin',
                        'userReducer',
                        'manager',
                        'auditor'
                    ]
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        const user = {
                            id: response.data.id,
                            email: response.data.email,
                            accessToken: response.data.access_token,
                        };

                        if (response.data.admin) {
                            user.name = response.data.admin.name;
                            user.level = USER_TYPE.ADMIN
                        } else if (response.data.auditor) {
                            user.name = response.data.auditor.name;
                            user.level = USER_TYPE.AUDITOR
                        } else if (response.data.manager) {
                            user.name = response.data.manager.name;
                            user.level = USER_TYPE.MANAGER
                        }

                        this.props.storeUser(user);
                        setTimeout(() => {
                            this.props.history.push('/');
                        }, 1000);
                    }
                })
        }
    };

    render() {
        return (
            <Row
                style={{
                    height: '100vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <Col md={6} lg={6} className='bg-login' style={{backgroundImage: `url(${bgLogin})`}}>
                    <Col className='bg-transparency'/>
                    <Col className='transparency' style={{backgroundImage: `url(${transparency})`}}/>
                </Col>
                <Col md={6} lg={6}>
                    <Row className='box-row'>
                        <Col md={6} lg={8}>
                            <Card>
                                <AuthForm
                                    authState={this.props.authState}
                                    onChangeAuthState={this.handleAuthState}
                                    onSubmit={this.handleSubmit}
                                    onLogoClick={this.handleLogoClick}
                                />
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({storeUser: login}, dispatch);

export default connect(null, mapDispatchToProps)(AuthPage);



// WEBPACK FOOTER //
// ./src/pages/AuthPage.js